import {combineReducers} from '@reduxjs/toolkit';

import {profileHistoryRecordSlice} from './slices/profile-history-record.slice';
import {profileHistoryStateSlice} from './slices/profile-history-state.slice';
import {profileHistorySlice} from './slices/profile-history.slice';

export const profileHistoryReducer = combineReducers({
    result: profileHistorySlice.reducer,
    state: profileHistoryStateSlice.reducer,

    historyRecord: profileHistoryRecordSlice.reducer,
});
